/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Rider } from '../../models/rider';

export interface RacesRaceGuidRidersPost$Params {
  raceGuid: string;
      body: Array<Rider>
}

export function racesRaceGuidRidersPost(http: HttpClient, rootUrl: string, params: RacesRaceGuidRidersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Rider>>> {
  const rb = new RequestBuilder(rootUrl, racesRaceGuidRidersPost.PATH, 'post');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Rider>>;
    })
  );
}

racesRaceGuidRidersPost.PATH = '/races/{raceGuid}/riders';
